// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1vu5Y","savePackageButton":"ClientWallet_savePackageButton__1Y-rt"};